import name from './name'

const selectSliceData = state => state[name]
const selectCatalogList = state => selectSliceData(state).catalogList
const selectCatalogListTotal = state => selectSliceData(state).catalogListTotal
const selectCategoryContent = state => selectSliceData(state).categoryContent
const selectCategoryContentOriginal = state => selectSliceData(state).categoryContentOriginal

export { selectCatalogList, selectCatalogListTotal, selectCategoryContent, selectCategoryContentOriginal }
